import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Spin,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getPatients } from '../../../network/appointment';
import {
  getEligibilityPlans,
  getInsurancePayors,
  getPatientInsurancePolicies,
} from '../../../network/PatientInsurancePolicy';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import StatusTag from '../../../hooks/StatusHook';
import { getModeOfPayments } from '../../../network/PaymentEntry';
import { addInsuranceClaim, getInsuranceClaimDetails, getInsuranceClaimFilter, updateInsuranceClaim } from '../../../network/InsuranceClaim';
const InsuranceClaimAdd = ({ t, edit }) => {
  // addPatientInsurancePolicy;
  const { id } = useParams();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const navigate = useNavigate();
  const client = useQueryClient();
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const { data: patients } = useQuery({
    queryKey: [queryKeys.getPatients],
    queryFn: () => getPatients(),
    keepPreviousData: true,
  });
  const { data: policies } = useQuery({
    queryKey: [queryKeys.getPatientInsurancePolicies],
    queryFn: () => getPatientInsurancePolicies(),
    keepPreviousData: true,
  });
  const { data: payors } = useQuery({
    queryKey: [queryKeys.getInsurancePayors],
    queryFn: () => getInsurancePayors(),
    keepPreviousData: true,
  });
  const { data: plans } = useQuery({
    queryKey: [queryKeys.getEligibilityPlans],
    queryFn: () => getEligibilityPlans(),
    keepPreviousData: true,
  });
  const { mutate: onAddInsuranceClaim } = useMutation({
    mutationKey: ['addInsuranceClaim'],
    mutationFn: (body) =>
      edit ? updateInsuranceClaim({ body, id }) : addInsuranceClaim(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data, 'datawwww');
      if (data?.message?.status === 500 || data === undefined) {
        message.error(data?.message?.message || 'Something went wrong !');
        return false;
      }
      message.success(
        data?.message?.message || edit
          ? ' Insurance Claim Edited Successfully'
          : 'Insurance Claim Added Successfully'
      );
      client.invalidateQueries({
        queryKey: [queryKeys.getInsuranceClaim],
      });
      form.resetFields();
      navigate('/insurance_claim');
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      // message.error(error);
    },
  });
  const onFinish = (values) => {
    console.log('Finish:', values);
    setLoadingAdd(true);
    onAddInsuranceClaim({
      ...values,
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      due_date: dayjs(values?.due_date).format('YYYY-MM-DD'),
      from_date: dayjs(values?.from_date).format('YYYY-MM-DD'),
      to_date: dayjs(values?.to_date).format('YYYY-MM-DD'),
      posting_date_based_on:"Insurance Coverage",
    });
  };


  const { data: dataById, isLoading } = useQuery({
    queryKey: [queryKeys.getInsuranceClaimDetails, id],
    queryFn: () => getInsuranceClaimDetails(id),
    enabled: !!edit,
    keepPreviousData: true,
  });
  const { data: modeOfPayments } = useQuery({
    queryKey: [queryKeys.getModeOfPayments],
    queryFn: () => getModeOfPayments(),
    keepPreviousData: true,
    select: (data) => data?.message?.mode_of_payments,
  });
  const insurance_policy = Form.useWatch('insurance_policy', form);
  const patient = Form.useWatch('patient', form);
  const insurance_payor = Form.useWatch('insurance_payor', form);
  const from_date = Form.useWatch('from_date', form);
  const to_date = Form.useWatch('to_date', form);


const { data: getClaimFilter,isError : getClaimFilterIsError } = useQuery({
    queryKey: [queryKeys.getInsuranceClaimFilter, insurance_policy,patient,insurance_payor,from_date,to_date],
    queryFn: () => getInsuranceClaimFilter({patient, insurance_policy,insurance_payor,from_date:dayjs(from_date).format('YYYY-MM-DD'),to_date:dayjs(to_date).format('YYYY-MM-DD')}),
    enabled: !!insurance_policy && !!patient && !!insurance_payor && !!from_date && !!to_date,
    onSuccess: (data) => {
      console.log(data, 'dataaaaaaaaaaaaaaaaa 88888888888');
      // form?.setFieldsValue({  });
    },
    onError: (error) => {
      console.log('error:', error);
      message.error('No matching Patient Insurance Coverages found, please check the dates');
    },
  });

  useEffect(() => {
    if (getClaimFilterIsError) {
      message.error('No matching Patient Insurance Coverages found, please check the dates');
    }
  }, [getClaimFilterIsError, message]);

  useEffect(() => {
    if (getClaimFilter) {
        form.setFieldsValue({
            coverages: getClaimFilter?.message
        })
    }  
    else if (edit) {
        form.setFieldsValue({
            coverages: dataById?.data?.coverages
        })
    } 
    else {
        form.setFieldsValue({
            coverages: [{}]
        })
    }
  }, [getClaimFilter, form, edit, dataById?.data?.coverages]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '80vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div className="patient-insurance-policy">
      <Card>
        <Flex align="center" justify="space-between" style={{ marginBottom: 10 }} className="page-header">
          <h4 className="title-card">{edit ? t.EDITINSURANCECLAIMINFORMATION : t.ENTERINSURANCECLAIMINFORMATION}</h4>
          {
            edit &&
          <StatusTag status={dataById?.data?.status} />
          }
        </Flex>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
          initialValues={
            edit
              ? {
                  ...dataById?.data,
                  posting_date: dayjs(dataById?.data?.posting_date),
                  due_date: dayjs(dataById?.data?.due_date),
                  from_date: dayjs(dataById?.data?.from_date),
                  to_date: dayjs(dataById?.data?.to_date),
                }
              : {

                coverages: [{}],
              }
          }
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient"
                label={t.patientFileNumber}
                rules={[
                  {
                    required: true,
                    message: t.requiredPatientFileNumber,
                  },
                ]}
              >
                <Select
                  placeholder={t.patientFileNumber}
                  options={patients?.message?.message?.map((item) => ({
                    value: item?.name,
                    label: item?.custom_file_number,
                    data: item,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="posting_date"
                label={t.postingDate}
                initialValue={dayjs()}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  placeholder={t.postingDate}
                  style={{ width: '100%' }}
                  defaultValue={dayjs()}
                  format="YYYY-MM-DD"
                  disabledDate={
                    (current) => current && current < dayjs().startOf('day')
                  }
                />
              </Form.Item>
            </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="due_date"
                label={t.dueDate}
                initialValue={dayjs()}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  placeholder={t.dueDate}
                  style={{ width: '100%' }}
                  defaultValue={dayjs()}
                  format="YYYY-MM-DD"
                  disabledDate={
                    (current) => current && current < dayjs().startOf('day')
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="from_date"
                label={t.fromDate}
                initialValue={dayjs()}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  placeholder={t.fromDate}
                  style={{ width: '100%' }}
                  defaultValue={dayjs()}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="to_date"
                label={t.ToDate}
                initialValue={dayjs().add(1, 'day')}
                rules={[
                  {
                    required: true,
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value && getFieldValue('from_date') > value) {
                        return Promise.reject(t.toDateGreaterThanFromDate);
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  placeholder={t.ToDate}
                  style={{ width: '100%' }}
                //   defaultValue={dayjs()}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Divider style={{ marginTop: 0 }} placement="left">
                Insurance Details
              </Divider>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="insurance_policy"
                label={t.insurancePolicy}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t.insurancePolicy}
                  options={policies?.data?.map((item) => ({
                    value: item?.name,
                    label: item?.name,
                    option: item,
                  }))}
                  onChange={(value, option) => {

                    console.log(option);
                    form.setFieldsValue({
                      insurance_payor: option?.option?.insurance_payor,
                      policy_number: option?.option?.policy_number,
                      policy_expiry_date: dayjs(
                        option?.option?.policy_expiry_date
                      ),
                      insurance_plan: option?.option?.insurance_plan,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="insurance_payor"
                label={t.insurancePayor}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t.insurancePayor}
                  // onChange={(value, option) => {
                  //     console.log(option,'option in onChange');
                      
                  // }}
                  options={payors?.message?.insurance_payors?.map((item) => ({
                    value: item?.name,
                    label: item?.insurance_payor_name,
                    option: item
                  }))} 
                  // disabled
                />
                {/* <Input placeholder={t.insurancePayor} disabled /> */}
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="policy_number"
                label={t.PolicyNumber}
              >
                <Input type="number" placeholder={t.PolicyNumber} disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="insurance_plan"
                label={t.InsurancePlan}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Select
                  placeholder={t.InsurancePlan}
                  options={plans?.message?.eligibility_plans?.map((item) => ({
                    value: item?.name,
                    label: item?.insurance_plan_name,
                  }))}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="mode_of_payment"
                label={t.ModeofPayment}
                // label={t.name}
                rules={[{ required: true }]}
              >
                <Select
                  placeholder={t.ModeofPayment}
                    onChange={
                      (value, option) => {
                        console.log(option, 'optionmmmmmmm');
                        form.setFieldsValue({
                          payment_account: option?.data?.accounts[0]?.default_account,
                        });
                      }
                    }
                  options={modeOfPayments?.map((appointment) => ({
                    value: appointment?.name,
                    label: appointment?.mode_of_payment,
                      data: appointment,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="payment_account"
                label={t.paymentAccount}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.paymentAccount} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Divider style={{ marginTop: 0 }} placement="left">
              coverages
              </Divider>
            </Col>
            <Col span={24} className="items-form-add">
  <Form.List name="coverages" style={{ width: '100%' }}>
    {(fields, { add, remove }) => (
      <>
        {fields?.map(({ key, name, ...restField }) => {
          const status = form.getFieldValue(['coverages', name, 'status']);
          return (
            <Flex
              key={key}
              align='center'
              gap={10}
              style={{
                width: '100%',
              }}
            >
              <Form.Item
                name={[name, 'patient_name']}
                label={t.patientName}
                style={{
                  width: '100%',
                  marginBottom: '0px',
                }}
                {...restField}
              >
                <Input placeholder={t.patientName} disabled />
              </Form.Item>
              <Form.Item
                name={[name, 'item_code']}
                label={t.itemCode}
                style={{
                  width: '100%',
                  marginBottom: '0px',
                }}
                {...restField}
              >
                <Input placeholder={t.itemCode} disabled />
              </Form.Item>
              <Form.Item
                name={[name, 'claim_amount']}
                label={t.claimAmount}
                style={{
                  width: '100%',
                  marginBottom: '0px',
                }}
                {...restField}
              >
                <Input placeholder={t.claimAmount} disabled />
              </Form.Item>
              {status === 'Rejected' && (
                <Form.Item
                  name={[name, 'payment_error_reason']}
                  label={t.paymentErrorReason}
                  style={{
                    width: '100%',
                    marginBottom: '0px',
                  }}
                  {...restField}
                >
                  <Input placeholder={t.paymentErrorReason} disabled />
                </Form.Item>
              )}

              <Form.Item
                name={[name, 'status']}
                label={t.status}
                style={{
                  width: '100%',
                  marginBottom: '0px',
                }}
                {...restField}
              >
                <Input placeholder={t.status} disabled />
              </Form.Item>
            </Flex>
          );
        })}
      </>
    )}
  </Form.List>
</Col>


          </Row>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => navigate(-1)}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default InsuranceClaimAdd;
